export default "__VITE_ASSET__b1172216__"